import { NumberParam, StringParam } from "use-query-params";

// search params config
export const queryParamsConfig = {
  page: NumberParam,
  pageSize: NumberParam,
  search: StringParam,
  sortDirection: NumberParam,
  sortColumn: StringParam,
};

export const initialFilter = {
  page: 1,
  pageSize: 15,
};

export const ExtraerFormBonoSerie = (form: string) => {
  if (form === null || form === "") return null;

  return form.substring(0, 2);
};

export const ExtraerFormBonoNum = (form: string) => {
  if (form === null || form === "") return null;

  if (form.length < 5) return null;

  return form.substring(2, form.length - 2);
};
